import React, { Component } from 'react';
import Box from '@mui/material/Box';

class ToS extends Component {
  render() {
    return (
      <div>
        <Box display='flex' justifyContent='center' className='title'>
          <h1>Session Token Claims Terms and Conditions</h1>
        </Box>

        <Box m='8px' mt='3em' mb='2em' className='readable'>
          <h2>Introduction</h2>
          <p>
            By accessing and/or using the token bridge made available by us to
            support the migration of OXEN Coins or wOXEN Tokens to Session
            Tokens, including the features available via the website located at
            https://claim.oxen.io (and each other website, application or
            other portal made available for a similar or equivalent purpose)
            (“Interface”), the tools related to bridging these assets provided
            through the Interface, and interacting with the smart contracts and
            other Session Protocol software related to bridging these assets
            (collectively, the “Software”), you agree that: (i) you have read
            and understood these terms and conditions (“Terms”); and (ii) you
            agree to comply with and shall be bound by these Terms, which set
            forth the legally binding terms and conditions governing your use of
            the Software and bridging activities related to the Session Protocol
            via the Software. Read these Terms carefully and review these Terms
            periodically to ensure you are aware of and in compliance with the
            most current version.
          </p>
          <p>
            If you do not agree to these Terms, you must not use the Software.
          </p>
          <p>
            Section titles in these Terms are for convenience only and have no
            legal or contractual effect.
          </p>
          <h2>Definitions</h2>
          <p>
            <ul>
              <li>
                "We," "us," and "our" refer to the developers, operators, and
                maintainers of the Software working for, on behalf of, or at the
                direction of the Session Technology Foundation.
              </li>
              <li>"You" and "your" refer to the user of the Software.</li>
              <li>
                “OXEN Coin” refers to the cryptographically secured digital coin
                issued by OPTF Ltd known as the OXEN coin that has been used as
                part of the operations of the software underlying the Oxen
                network.
              </li>
              <li>
                “wOXEN Coin” refers to the “wrapped” version of OXEN Coin, being
                the cryptographically secured digital token using the ERC20
                standard and deployed on the Ethereum blockchain representing
                (and exchangeable for) an OXEN Coin.
              </li>
              <li>
                “Session Protocol” refers to the Session messaging protocol, and
                the blockchain, smart contracts, and other associated software
                relating to the decentralised services associated with the
                Session messaging application.
              </li>
              <li>
                “Session Token” refers to the cryptographically secured digital
                token known as the Session Token (or SESH) that has been (or
                will be) issued and intended to be used as part of the
                operations of the software underlying the Session messaging
                application and Session Protocol.
              </li>
            </ul>
          </p>
          <h2>Purpose, access and use</h2>

          <p>
            The Software is provided to facilitate migrating OXEN Coins and
            wOXEN Tokens to receive Session Tokens (the “Permitted Purpose”).
          </p>
          <p>
            In order to access and/or use the Interface and its associated
            functions including access and/or use of the bridging functionality
            of the Session Protocol via the Interface, you will first be
            required to connect a compatible and supported non-custodial digital
            assets wallet (a “Supported Wallet”).
          </p>
          <p>You acknowledge and agree that:</p>
          <p>
            <ul>
              <li>
                You must be at least 18 years of age and have reached the legal
                age of majority in the jurisdiction in which you reside (or, if
                you are not a natural person, you have capacity and authority to
                enter into and be bound by these Terms).
              </li>
              <li>
                You have all technical knowledge necessary or advisable to
                understand and evaluate the risks of using the Software.
              </li>
              <li>
                Any OXEN Coins or wOXEN Tokens that you bridge for Session
                Tokens via the Software are entirely within your ownership and
                control, can be dealt with by you without any encumbrance or
                other impediment, and are not from any illicit source or
                otherwise connected with any unlawful activity (including any
                money-laundering, terrorist financing, or sanctions violations).
                We are not responsible or liable for any OXEN Coins, wOXEN
                Tokens or Session Tokens that are improperly used or
                misappropriated in the use of the Software or that have been
                sent to an incorrect wallet address or a wallet address for a
                different blockchain or blockchain network. It is important for
                you to take precautions when transferring and storing your
                digital assets while using the Software or other sites, wallets
                or devices.
              </li>
              <li>
                We do not have access to, and cannot withdraw or transfer, any
                of your digital assets that are secured in any Supported Wallet
                and/or that you may elect to deploy in connection with bridging
                activity via the Software. We are not capable of performing
                transactions or sending messages on your behalf.
              </li>
              <li>
                We have not rendered any advice and/or made any recommendation
                in respect of your use of the Software or bridging OXEN Coins or
                wOXEN Coins to receive Session Tokens. We do not act as your
                agent, broker, adviser, trustee or fiduciary in any capacity.
                You must conduct your own due diligence and consult an
                independent adviser where appropriate with respect to your use
                of the Software.
              </li>
              <li>
                Nothing in these Terms, nor any information provided on or via
                the Interface, constitutes an offer or invitation to subscribe
                for any tokens, securities or financial products.
              </li>
              <li>
                You are solely responsible for establishing, providing or
                procuring, maintaining and supporting any operating environment,
                software and hardware, digital wallets (including, hardware
                wallets), facilities, equipment and telecommunications and
                internet connections necessary to use the Software, and to
                transfer and receive digital assets.
              </li>
              <li>
                By allowing you to connect with or otherwise supporting any
                integration or interaction with any third party software or
                service, we do not endorse or recommend that software or service
                and you use it at your own risk and in accordance with the terms
                governing the relationship between you and that software or
                service.
              </li>
              <li>
                You are solely responsible for the security of any Supported
                Wallet that you use, and any operating environment, software and
                hardware, digital wallets (including, hardware wallets),
                facilities, equipment, telecommunications and internet
                connections and other infrastructure that you may use from time
                to time in connection with the Software.
              </li>
              <li>
                You must comply, at all times, with all applicable laws and
                regulations and any other order, rule, policy or other binding
                instrument applicable to you.
              </li>
            </ul>
          </p>
          <p>You must not:</p>
          <p>
            <ul>
              <li>
                Use the Software for any purpose other than the Permitted
                Purpose.
              </li>
              <li>
                Introduce any malware, trojans, viruses, corruption or other
                malicious code to, or otherwise interfere with the operation of,
                the Software.
              </li>
              <li>
                Reverse disassemble, decompile or reverse engineer, or directly
                or indirectly allow or cause a third party to disassemble,
                decompile or reverse engineer the whole or any part of the
                Software, and its source code or otherwise attempt or allow any
                other party to attempt to obtain the algorithms by which the
                Software performs its functions (otherwise than with our express
                permission or pursuant to the terms of any open source license
                pursuant to which such Software is made available).
              </li>
              <li>
                Copy, modify or adapt the source code of the Software (otherwise
                than with our express permission or pursuant to the terms of any
                open source license pursuant to which such Software is made
                available).
              </li>
              <li>
                Use the Software in breach of any applicable laws or in
                connection with any fraudulent activity (including, without
                limitation, terrorist financing, money laundering; illegal
                gambling and malicious hacking).
              </li>
              <li>
                Take any action to compromise the integrity or security of the
                Software or otherwise use the Software in any way that is
                harmful, or disruptive to the Software or Session Protocol, or
                other users, or any third party’s software, services, products
                or users.
              </li>
            </ul>
          </p>
          <h2>License and intellectual property</h2>
          <p>
            We grant you a non-exclusive, non-transferable, revocable license to
            use the Software solely for Permitted Purpose, subject to these
            Terms.
          </p>
          <p>
            All intellectual property rights in the Software, including but not
            limited to copyrights, trademarks, and trade secrets, are owned by
            us or our licensors. You do not acquire any ownership rights by
            using the Software.
          </p>
          <h2>Disclaimers</h2>
          <p>
            The Software is provided "as is" and "as available," without any
            warranties of any kind, express or implied, including but not
            limited to warranties of merchantability, fitness for a particular
            purpose, or non-infringement.
          </p>
          <p>
            We are not liable for any loss or damage you may incur, directly or
            indirectly, as a result of your use of the Software (or any attempt
            to use the Software). In no event shall we be liable for any direct,
            indirect, incidental, consequential, or punitive damages arising out
            of or related to your use of the Software.
          </p>
          <h2>Bridging Disclaimer</h2>
          <p>
            We do not guarantee that the conversion ratio displayed in the
            Software at any given time will remain fixed or available in the
            future. The conversion ratio may be changed, updated, or withdrawn
            at our sole discretion.
          </p>
          <p>
            Additionally, access to the Software, including the bridging
            functionality, may be disabled or suspended at any time and for any
            reason, including but not limited to maintenance, security,
            regulatory, or operational concerns. In the event the Software is
            disabled, no further bridging may be possible, and we accept no
            responsibility or liability for any inability to access or use the
            Software or complete bridging actions as a result.
          </p>
          <h2>Termination</h2>
          <p>
            We reserve the right to terminate your access to the Software at any
            time, with or without cause, and without prior notice.
          </p>
          <h2>Changes to Terms</h2>
          <p>
            We may update these Terms from time to time. If we make material
            changes, we will notify you by posting the updated Terms on our
            website or through other means. Your continued use of the Software
            after such changes constitutes your acceptance of the updated Terms.
          </p>
          <p>
            We may communicate other information, policies, criteria and
            proposals with respect to the operation and administration of the
            Software and, where such communications include requirements,
            conditions, or other terms with respect to the Software, those
            communications will be deemed to form part of these Terms. In the
            event of any conflict or inconsistency between such communications
            and these Terms, these Terms prevail.
          </p>
          <h2>Governing Law</h2>
          <p>
            These Terms shall be governed by and construed in accordance with
            the laws of the Canton of Zug, Switzerland.
          </p>
          <h2>Contact Information</h2>
          <p>
            If you have any questions or concerns about these Terms, please
            contact contact@session.foundation
          </p>
        </Box>
      </div>
    );
  }
}

export default ToS;
